import React from "react";
import { observer } from "mobx-react";
import Slider from "react-slick";

import { MobileSettings } from "@utils/quick-play/slider";
import { useOfferContext } from "@state/hooks/offer/useOfferContext";
import { OfferStore } from "@state/context/offer/OfferContext";
import { BetBuilderPicksEventSliderItem } from "./components/BetBuilderPicksEventSliderItem";

export default observer(function BetBuilderPicksEventSlider() {
	const store = useOfferContext<OfferStore.EventViewStore>();

	if (
		!store?.betBoosterEventPicks?.betBuilderPicksStore?.betBuilderPresetIds
			?.length
	) {
		return null;
	}

	return (
		<div className="section section--play event__slider">
			<div className="section--play__body">
				<Slider {...MobileSettings} className="carousel carousel--most">
					{store?.betBoosterEventPicks?.betBuilderPicksStore?.betBuilderPresetIds?.map(
						(item, index) => {
							const slip =
								store?.betBoosterEventPicks?.betBuilderPicksStore?.BBPicks.get(
									item
								);

							if (!slip) {
								return null;
							}
							return (
								<BetBuilderPicksEventSliderItem
									key={slip.id}
									BBPick={slip}
									index={index}
								/>
							);
						}
					)}
				</Slider>
			</div>
		</div>
	);
});
